import React from "react";
import { Switch, Redirect, Route } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import Loadable from "react-loadable";

const Dashboard = Loadable({
  loader: () => import("./routes/dashboard"),
  loading: TopBarProgress,
});

const Profile = Loadable({
  loader: () => import("./routes/profile"),
  loading: TopBarProgress,
});

const Tracking = Loadable({
  loader: () => import("./routes/tracking"),
  loading: TopBarProgress,
});

const Deposits = Loadable({
  loader: () => import("./routes/deposits"),
  loading: TopBarProgress,
});

const Services = Loadable({
  loader: () => import("./routes/services"),
  loading: TopBarProgress,
});

const Performance = Loadable({
  loader: () => import("./routes/performance"),
  loading: TopBarProgress,
});

const Routes = Loadable({
  loader: () => import("./routes/routes"),
  loading: TopBarProgress,
});
const CreateRoutes = Loadable({
  loader: () => import("./routes/create-routes"),
  loading: TopBarProgress,
});
const ValidateAddress = Loadable({
  loader: () => import("./routes/create-routes/components/validate-address"),
  loading: TopBarProgress,
});
const ParcelIntent = Loadable({
  loader: () => import("./routes/create-routes/components/parcel-intent"),
  loading: TopBarProgress,
});
const Frequent = Loadable({
  loader: () => import("./routes/frequent"),
  loading: TopBarProgress,
});
const Origins = Loadable({
  loader: () => import("./routes/origins"),
  loading: TopBarProgress,
});
const Nationals = Loadable({
  loader: () => import("./routes/nationals"),
  loading: TopBarProgress,
});
const Overweight = Loadable({
  loader: () => import("./routes/overweight"),
  loading: TopBarProgress,
});
const Parcels = Loadable({
  loader: () => import("./routes/parcels"),
  loading: TopBarProgress,
});
const SameDay = Loadable({
  loader: () => import("./routes/sameday"),
  loading: TopBarProgress,
});
const Integrations = Loadable({
  loader: () => import("./routes/integrations"),
  loading: TopBarProgress,
});

const Developers = Loadable({
  loader: () => import("./routes/developers"),
  loading: TopBarProgress,
});

const CodDestinations = Loadable({
  loader: () => import("./routes/coddestinations"),
  loading: TopBarProgress,
});

const Boxes = Loadable({
  loader: () => import("./routes/boxes"),
  loading: TopBarProgress,
});

const Clients = () => (
  <Switch>
    <Route path="/dashboard">
      <Dashboard />
    </Route>
    <Route path="/tracking">
      <Tracking />
    </Route>
    <Route path="/profile">
      <Profile />
    </Route>
    <Route path="/sameday">
      <SameDay />
    </Route>
    <Route path="/deposits">
      <Deposits />
    </Route>
    <Route path="/services">
      <Services />
    </Route>
    <Route path="/performance">
      <Performance />
    </Route>
    <Route path="/coddestinations">
      <CodDestinations />
    </Route>
    <Route path="/routes">
      <Routes />
    </Route>
    <Route path="/createRoutes">
      <CreateRoutes />
    </Route>
    <Route path="/validateAddress">
      <ValidateAddress />
    </Route>
    <Route path="/parcelIntent">
      <ParcelIntent />
    </Route>
    <Route path="/frequent">
      <Frequent />
    </Route>
    <Route path="/origins">
      <Origins />
    </Route>
    <Route path="/nationals">
      <Nationals />
    </Route>
    <Route path="/overweight">
      <Overweight />
    </Route>

    <Route path="/parcels">
      <Parcels />
    </Route>
    <Route path="/integrations">
      <Integrations />
    </Route>
    <Route path="/developers">
      <Developers />
    </Route>
    <Route path="/boxes">
      <Boxes />
    </Route>
    <Redirect to="/dashboard" />
  </Switch>
);

export default Clients;
